import { render, staticRenderFns } from "./couponComponent.vue?vue&type=template&id=25f0fbf7&scoped=true&"
import script from "./couponComponent.vue?vue&type=script&lang=js&"
export * from "./couponComponent.vue?vue&type=script&lang=js&"
import style0 from "./couponComponent.vue?vue&type=style&index=0&id=25f0fbf7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f0fbf7",
  null
  
)

export default component.exports